import { render, staticRenderFns } from "./AnswerColumns.vue?vue&type=template&id=4b31355e&scoped=true"
import script from "./AnswerColumns.vue?vue&type=script&lang=js"
export * from "./AnswerColumns.vue?vue&type=script&lang=js"
import style0 from "./AnswerColumns.vue?vue&type=style&index=0&id=4b31355e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31355e",
  null
  
)

export default component.exports